import { render, staticRenderFns } from "./StockProductSearch.vue?vue&type=template&id=226613e4"
import script from "./StockProductSearch.vue?vue&type=script&lang=js"
export * from "./StockProductSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports